module.exports = __webpack_public_path__ + "img/banner_app.0bfa9f3f.png";